var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4508)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5914 7.34758C13.5914 8.31624 11.3119 8.78289 8.5 8.78289C5.68812 8.78289 3.40863 8.40396 3.40863 7.34758L3.22714 1.61595C3.22714 0.559576 5.68812 0.180664 8.5 0.180664C11.3119 0.180664 13.7729 0.647301 13.7729 1.61595L13.5914 7.34758ZM13.5914 8.82896C13.5914 8.78935 13.6299 8.75975 13.6695 8.7682C15.3823 9.13371 16.4688 9.73019 16.4688 10.5731C16.4688 12.1008 12.901 12.8195 8.49999 12.8195C4.09898 12.8195 0.53125 12.082 0.53125 10.5731C0.53125 9.74505 1.60601 9.14945 3.30286 8.78043C3.3565 8.76875 3.40862 8.80892 3.40862 8.86262V9.13776C3.40862 10.1941 5.6881 10.5731 8.49999 10.5731C11.3119 10.5731 13.5914 10.1064 13.5914 9.13776V8.82896Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 13,
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/Hat.e38b058cc196f30e4466823ccefec6e6.svg";
export { ForwardRef as ReactComponent };